export const TOS_VERSION = '2022-12';
